import { IAdvancedFraudTrendPattern, IListCheckEntry } from 'src/ts/interfaces/listCheck';
import { FraudTrendEvidenceResult } from '../../../../hooks/useFraudTrendEvidence';
import { PageView } from '../../textBoxes/TextBoxesPane';
import { textBoxesCopy } from '../../textBoxes/textBoxesCopy';

export interface PatternViewProps {
  entry: IListCheckEntry;
  pattern: IAdvancedFraudTrendPattern;
  evidence: FraudTrendEvidenceResult;
  visual: FraudTrendEvidenceResult;
  proofId: string | undefined;
  pdfUrl: string | null | undefined;
  pageView: PageView;
  showImage: boolean;
  onImageAvailable: (available: boolean) => void;
}

export const visualNotice = (
  entry: IListCheckEntry,
  visual: FraudTrendEvidenceResult
): string | null => {
  if (!entry.has_visual) return textBoxesCopy.noPageView;
  if (visual.status === 'idle' || visual.status === 'loading') return textBoxesCopy.loadingPageView;
  if (visual.status === 'missing') return textBoxesCopy.missing;
  if (visual.status === 'error') return textBoxesCopy.failed;
  return null;
};
